import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\DossierNumbering\GetDossierNumberingByIdController::__invoke
* @see app/Http/Controllers/DossierNumbering/GetDossierNumberingByIdController.php
* @route '/api/dossier-numbering/{dossier_numbering}'
*/
const GetDossierNumberingByIdController = (args: { dossier_numbering: string | number | { id: string | number } } | [dossier_numbering: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierNumberingByIdController.url(args, options),
    method: 'get',
})

GetDossierNumberingByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier-numbering/{dossier_numbering}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DossierNumbering\GetDossierNumberingByIdController::__invoke
* @see app/Http/Controllers/DossierNumbering/GetDossierNumberingByIdController.php
* @route '/api/dossier-numbering/{dossier_numbering}'
*/
GetDossierNumberingByIdController.url = (args: { dossier_numbering: string | number | { id: string | number } } | [dossier_numbering: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier_numbering: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier_numbering: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier_numbering: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier_numbering: typeof args.dossier_numbering === 'object'
        ? args.dossier_numbering.id
        : args.dossier_numbering,
    }

    return GetDossierNumberingByIdController.definition.url
            .replace('{dossier_numbering}', parsedArgs.dossier_numbering.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\DossierNumbering\GetDossierNumberingByIdController::__invoke
* @see app/Http/Controllers/DossierNumbering/GetDossierNumberingByIdController.php
* @route '/api/dossier-numbering/{dossier_numbering}'
*/
GetDossierNumberingByIdController.get = (args: { dossier_numbering: string | number | { id: string | number } } | [dossier_numbering: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierNumberingByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DossierNumbering\GetDossierNumberingByIdController::__invoke
* @see app/Http/Controllers/DossierNumbering/GetDossierNumberingByIdController.php
* @route '/api/dossier-numbering/{dossier_numbering}'
*/
GetDossierNumberingByIdController.head = (args: { dossier_numbering: string | number | { id: string | number } } | [dossier_numbering: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDossierNumberingByIdController.url(args, options),
    method: 'head',
})

export default GetDossierNumberingByIdController